import { Decimal } from 'decimal.js-light';
import { DECIMAL_DIGITS } from 'src/modules/common/constants.ts';

export const steamCalcConstants = {
    gamma: new Decimal(1.13),
    fgamma: new Decimal(0.81),
    xt: new Decimal(0.72),
    t1: new Decimal(150),
    temp1: new Decimal(423.15),
    r: new Decimal(47.06),
};

export const calcKvSpecificVolume = (p1: Decimal) => {
    const s1 = steamCalcConstants.r.mul(steamCalcConstants.temp1).dividedBy(p1.mul(new Decimal(100000 / 9.81)));
    const s2 = new Decimal(0.9172).dividedBy(steamCalcConstants.temp1.dividedBy(100).pow(2.82));
    const s3 = p1.mul(new Decimal(100000 / 9.81)).pow(2);
    const s4 = new Decimal(1.3088).mul(new Decimal(10).pow(-4))
        .dividedBy(steamCalcConstants.temp1.dividedBy(100).pow(14));
    const s5 = new Decimal(4.379).mul(new Decimal(10).pow(7))
        .dividedBy(steamCalcConstants.temp1.dividedBy(100).pow(31.6));
    return s1.minus(s2).minus(s3.mul(s4.plus(s5)));
};

export const calcMinDnSteam = (massFlowString: string, outletString: string) => {
    try {
        const massFlow = new Decimal(massFlowString);
        const outlet = new Decimal(outletString);
        const v2 = calcKvSpecificVolume(outlet);
        const rho2 = v2.pow(-1);
        return new Decimal(3.54).mul(massFlow).dividedBy(rho2).pow(0.5).toFixed(DECIMAL_DIGITS);
    } catch {
        return '';
    }
};

export const calcKvsSteam = (massFlowString: string, inletString: string, outletString: string): string => {
    try {
        const massFlow = new Decimal(massFlowString);
        const inlet = new Decimal(inletString);
        const outlet = new Decimal(outletString);
        if (inlet.toNumber() === 0) {
            return '';
        }
        const delta = inlet.minus(outlet);
        const x = delta.dividedBy(inlet);
        const y = new Decimal(1).minus(
            x.dividedBy(new Decimal(3).mul(steamCalcConstants.fgamma).mul(steamCalcConstants.xt)),
        );

        const v1 = calcKvSpecificVolume(inlet);
        const rho1 = v1.pow(-1);
        const qv = massFlow.dividedBy(rho1);

        return qv.mul(rho1).dividedBy(new Decimal(31.6).mul(y).mul(
            x.mul(inlet).mul(rho1).pow(0.5),
        )).toFixed(DECIMAL_DIGITS);
    } catch {
        return '';
    }
};
